import { isDefinedArray, isDefinedString, reduce } from "et3-type-guards";

import { EApprovalDescriptionStatus } from "../../constants/enum/approval-description-status";
import { EApprovalPictureStatus } from "../../constants/enum/approval-picture-status";
import { PICTURE_IS_ACTIVE } from "../../constants/input-entries-constants";
import { TApprovalAlbumPicture, TUserEntry } from "../../Types";

export const countPendingPictures = (userEntry: TUserEntry) => {
  const albumPicture = reduce<TApprovalAlbumPicture[]>(
    () => userEntry.albumPicture,
    []
  );
  if (!isDefinedArray(albumPicture)) {
    return 0;
  }
  return albumPicture.filter((picture) => {
    const status = reduce(() => `${picture.status}`, "");
    const isActive = reduce(() => picture.isActive, 0);
    return (
      status === EApprovalPictureStatus.PENDING &&
      isActive === PICTURE_IS_ACTIVE
    );
  }).length;
};

export const countActivePictures = (userEntry: TUserEntry) => {
  const albumPicture = reduce<TApprovalAlbumPicture[]>(
    () => userEntry.albumPicture,
    []
  );
  if (!isDefinedArray(albumPicture)) {
    return 0;
  }
  return albumPicture.filter((picture) => {
    return isDefinedString(reduce(() => `${picture.picture}`, ""));
  }).length;
};

export const isSelfDescriptionPending = (userEntry: TUserEntry) => {
  return (
    reduce(() => `${userEntry.descriptionStatus}`, "") ===
    EApprovalDescriptionStatus.PENDING
  );
};

export const isPeerDescriptionPending = (userEntry: TUserEntry) => {
  return (
    reduce(() => `${userEntry.peerDescriptionStatus}`, "") ===
    EApprovalDescriptionStatus.PENDING
  );
};

export const countPendingItems = (userEntry: TUserEntry) => {
  const pendingDescriptions = [
    isSelfDescriptionPending(userEntry),
    isPeerDescriptionPending(userEntry)
  ].filter((isPending) => isPending).length;
  return countPendingPictures(userEntry) + pendingDescriptions;
};
